<section class="landing-login parking-lotpage">  
  <app-header-v1 [presentComponent]="presentComponent"></app-header-v1>

<div class="parkinglot-bannersec driverv1-banner">
    <div class="bg-img">
      <img
        src="../../assets/images/landing-page/parking-banner-bg.png"
        alt="Banner Background"
        class="img-fluid"
      />
    </div>
    <div class="landing-container">
      <div class="driver-v1">
        <h1 class="banner-heading">The ideal platform for fleet parking</h1>
      </div>

      <div class="banner-btnbox">
        <a class="banner-btn" routerLink="/login"> Book Now </a>
      </div>
      <div class="banner-img parking-img desktop-outer">
        <img
          src="../../assets/images/group-reservation.png"
          alt="Group Reservation"
          class="img-fluid"
        />
      </div>      
      <app-feature-box [features]="features"></app-feature-box>
    </div>
  </div>

<div>
    <div class="map-box">
      <app-join-our-community-map></app-join-our-community-map>
    </div>
  </div>
</section>
<app-footer></app-footer>
